<template>
  <div :style="`height: 200px; width: ${isTeam?'100%':'50%'};`" class="pr-2 pb-2">
    <v-card class="d-flex fill-height">
      <v-card-text style="position: relative;" class="align-self-stretch">
        <!--    -->
        <v-row v-if="loading" style="position: absolute; left: 12px; top:0px; width: 100%; height: 100%;"
               justify="center" align="center">
          <v-progress-circular indeterminate color="accent" size="64"/>
        </v-row>
        <v-row v-else style="position: absolute; left: 12px; top:0px; bottom: 0; right: 12px">
          <v-col :cols="12" class="d-flex flex-column justify-space-between">
            <h6 class="body-1 ml-1 mt-0 text-no-wrap text-truncate text-center">{{ activity.name }}</h6>
            <v-row class="justify-space-around pt-0 mr-0 ml-0 flex-grow-0 flex-shrink-1">
              <v-col v-if="isTeam" class="pa-0 flex-grow-1 flex-shrink-0">
                <div class="text-center">
                  <span class="display-1">{{ formatDE(ownWeekSum) }}</span><span>/{{ formatDE(weekTarget) }}</span>
                </div>
                <div class="text-center text-no-wrap body-1">Eigen</div>
              </v-col>
              <v-col v-if="isTeam" class="pa-0 flex-grow-1 flex-shrink-0">
                <div class="text-center mt-n5">
                  <span class="display-4">{{ formatDE(totalWeekSum) }}</span>
                </div>
                <div class="body-1 text-center text-no-wrap">{{ unit }} pro Woche</div>
              </v-col>
              <v-col v-if="isTeam" class="pa-0 flex-grow-1 flex-shrink-0">
                <div class="text-center">
                  <span class="display-1">{{ formatDE(teamWeekSum) }}</span>
                </div>
                <div class="text-center text-no-wrap body-1">Team</div>
              </v-col>
              <v-col v-if="!isTeam" class="pa-0 flex-grow-1 flex-shrink-0">
                <div class="text-center">
                  <span class="display-3">{{ formatDE(ownWeekSum) }}</span><span>/{{ formatDE(weekTarget) }}</span>
                </div>
                <div class="body-1 text-center text-no-wrap">{{ unit }} pro Woche</div>
              </v-col>

              <!--            <div class="flex-grow-1"></div>-->
              <!--            <div class="d-flex flex-column pa-0 flex-grow-0 flex-shrink-0">-->
              <!--                <div class="text-center display-3">{{calcIndex(values[6])}}</div>-->
              <!--                <div class="text-center caption">heute</div>-->
              <!--            </div>-->
            </v-row>
          </v-col>
        </v-row>
        <!--        <bar-chart class="mt-5" ref="vuechart" :chartdata="chartData" :options="options" :height="80"/>-->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

//import BarChart from "@/components/Charts/BarChart";


const {DateTime} = require("luxon");
import {formatDE, round} from "@/reusable/numbers";
import Bereiche from "@/components/Bereiche";
import Kinds from "@/components/Kinds";
import Activity from "@/components/Activity";
import ActivityLibrary from "@/components/ActivityLibrary";
import {Ziele} from "@/components/Ziele";

export default {
  name: "TeamNumValueWeek",
  //components: {BarChart},
  props: ['activity', 'date', 'treenode', 'targets'],
  data() {
    return {
      loading: false,
      datetime: undefined,
      //values: [],
    }
  },
  mounted() {
    //this.reload();
    //this.chart = this.$refs.vuechart._data._chart;
    //this.canvas = this.chart.canvas;
    var self = this;
    //this.$nextTick(() => self.updateChart());
  },
  methods: {
    getTextStyle(bereich) {
      return {'color': Bereiche.COLORS_BY_NAME[bereich]};
    },
    formatDE(val) {
      return formatDE(val);
    },
  },
  computed: {
    isTeam() {
      var n = this.treenode;
      return n && n.teamIndex !== undefined;
    },
    totalWeekSum() {
      var n = this.treenode;
      if (this.isTeam) {
        return round((n.teamActivitySums || {})['total/'+this.activity.id] || 0, 1);
      }
      return round((n.activitySums || {})[this.activity.id] || 0, 1);
    },
    ownWeekSum() {
      var n = this.treenode;
      if (this.isTeam) {
        return round((n.teamActivitySums || {})['own/'+this.activity.id] || 0, 1);
      }
      return round((n.activitySums || {})[this.activity.id] || 0, 1);
    },
    teamWeekSum() {
      var n = this.treenode;
      if (!this.isTeam)
        return 0;
      return round((n.teamActivitySums || {})['team/'+this.activity.id] || 0, 1);
    },
    bereiche() {
      return Bereiche.NAMES;
    },
    weekTarget() {
      var targets=this.targetValues;
      var actiTarget = this.activity.target;
      var aid=this.activity.id;
      //console.log(this.activity.name, targets ? targets[this.activity.id] : "null", "acti:", actiTarget);
      var t=!targets  ? actiTarget : (targets[aid] || 0);
      if (this.activity.freq === ActivityLibrary.FREQ_WEEKLY)
        return t;
      else if (this.activity.type === ActivityLibrary.TYPE_BOOL)
        return 7;
      else
        return t * 7;
    },
    unit() {
      if (this.activity.type === ActivityLibrary.TYPE_BOOL)
        return "mal";
      return this.activity.unit;
    },
    targetValues() {
      if (!this.targets)
        return undefined;
      return new Ziele(this.targets).getTargets(this.date);
    }
  },
  watch: {

  }
}
</script>

<style scoped>

</style>